module.exports = __webpack_public_path__ + "img/MZ.a0363054.png";